import React from 'react';
import { useParams } from 'react-router-dom';

import { SchedulerCancel } from 'components/Scheduler';

import './public-scheduler.scss';

const SchedulerCancelPage = () => {
  const { bookingRef } = useParams();

  return (
    <div className="public-scheduler-page">
      <SchedulerCancel
        bookingRef={bookingRef}
      />
    </div>
  );
};

export default SchedulerCancelPage;
